<template>
  <div class="content c895">
    <h2>Pomivalni stroj 1</h2>
  </div>
  <div class="content c590">
    <div class="popup popDev6" style="display:none;">
      <div class="inner">
        <h3>Ali ste prepričani, da želite izbrisati napravo?</h3>
        <div class="msg">
          <h3>Pomivalni stroj</h3>
        </div>
        <div class="con">
          <p>Izbrišite napravo, če ste se zmotili pri njenih podatkih oziroma ste izbrali napačno napravo. Če bi želeli, jo lahko kasneje brez težav ponovno dodate.</p>
        </div>
        <div class="btns">
          <a
            href="javascript:void(0)"
            class="btn"
            title="Več"
            onclick="popupDelete(&quot;popDev6&quot;)"
          >NE, PREKLIČI</a>
          <a
            id="ctl00_ContentPlaceHolder1_lnkBtnDeleteDevice"
            class="btn"
            href="javascript:__doPostBack('ctl00$ContentPlaceHolder1$lnkBtnDeleteDevice','')"
          >DA, IZBRIŠI</a>
        </div>
      </div>
    </div>
    <div class="appliance">
      <table>
        <tbody>
          <tr>
            <td class="first">Pomivalni stroj</td>
            <td>A++</td>
            <td class="last">
              <div class="tools">
                <a
                  href="javascript:void(0)"
                  title="Zbriši"
                  class="close"
                  onclick="popupDelete(&quot;popDev6&quot;)"
                >Zbriši</a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="appliance data">
      <div class="icon">
        <span class="PX">Pomivalni stroj</span>
      </div>
      <div class="first">
        <h5>TRENUTNA PORABA</h5>
        <span id="ctl00_ContentPlaceHolder1_lblConsumption">
          <span class="et">
            299 kWh / leto
            <div class="tooltip-bottom">
              Enotna tarifa (ET) je tarifa, ki jo beleži enotarifni števec vsak dan od 0.00 do 24.00 ure. Cena električne energije je ves čas enaka. V primeru, da imate enotarifno merjenje in želite dvotarifnega, pokličite v vaše elektrodistribucijsko podjetje za podrobnejše informacije.
              <br />
              <a
                href="http://www.uresnicujmo.si/o_aplikaciji_za_izracun_prihrankov/predstavitev#tarife"
                target="_blank"
                title="Več"
              >Več o tem &gt;</a>
            </div>
          </span>
        </span>
        <em>
          <span id="ctl00_ContentPlaceHolder1_lblTotalPrice">22,57 € / leto</span>
        </em>
      </div>

      <div class="no-data">
        <h5>VAŠI PRIHRANKI</h5>
        <h5>VAŠA NOVA PORABA</h5>
        <div class="message">
          <p>Za izračun nove porabe in prihrankov na izbrani napravi izvedi vsaj en ukrep.</p>
        </div>
      </div>
    </div>
    <div class="actions">
      <div class="toggle-btn" style="display:none;">
        <a href="javascript:void(0)" class="active">Prihranki zaradi izvedenih ukrepov</a>
      </div>
      <ul class="actionsExistingUl"></ul>

      <h3>Zmanjšajte porabo naprave Pomivalni stroj</h3>
      <p>Zmanjšajte porabo tako, da izvedete vsaj enega, še bolje pa več, spodaj navedenih ukrepov. Izberite le tiste, ki so v vaših razmerah pomembni.</p>
      <ul>
        <li id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_divAction">
          <a
            class="actionBtnMore active"
            style="cursor:pointer;"
          >Zamenjamo naš stari pomivalni stroj z novim, ki je energetsko bolj učinkovit</a>

          <div style class="actionPnlMore">
            <div id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_Panel3">
              <div class="form">
                <h3>Izberite lastnosti novega Pomivalnega stroja:</h3>
                <fieldset>
                  <div class="f-item select">
                    <label>
                      Energijski razred:
                      <span>(oz. leto izdelave naprave)</span>
                    </label>
                    <span
                      id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_RequiredFieldValidator3"
                      style="color:Red;float:none;font-size:1em;visibility:hidden;"
                    >*</span>
                    <select
                      name="ctl00$ContentPlaceHolder1$RepeaterActions$ctl00$ddlClassDishwasher"
                      id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_ddlClassDishwasher"
                    >
                      <option value="0">Izberite</option>
                      <option value="78">A (po 2007)</option>
                      <option value="177">A+</option>
                      <option value="178">A++</option>
                      <option value="79">B (2001-2007)</option>
                      <option value="179">A+++</option>
                      <option value="80">C (1999-2001)</option>
                      <option value="81">D (1992-1999)</option>
                      <option value="82">E (pred 1992)</option>
                      <option value="83">F (pred 1992)</option>
                      <option value="84">G (pred 1992)</option>
                    </select>
                    <!-- tooltip + div added-->
                    <div class="help">
                      <a href="#" class="help" title="Help">Help</a>
                      <div
                        class="tooltip"
                      >Tako kot pri pralnih, je tudi pri pomivalnih strojih način pranja tisti, ki definira porabo električne energije. Poraba ali prihranek sta najbolj odvisna od navad v vaši družini.</div>
                    </div>
                    <!-- //end -->
                  </div>
                </fieldset>
              </div>
            </div>

            <div class="advice">
              <div class="right">
                <a
                  id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl00_lnkBtnAdd"
                  class="btn"
                  href="javascript:WebForm_DoPostBackWithOptions(new WebForm_PostBackOptions(&quot;ctl00$ContentPlaceHolder1$RepeaterActions$ctl00$lnkBtnAdd&quot;, &quot;&quot;, true, &quot;ChangeDevice&quot;, &quot;&quot;, false, true))"
                >Izvedi ukrep</a>
              </div>
              <p>Na porabo pomivalnega stroja primarno vplivata njegova starost in s tem povezana energijska učinkovitost in zmogljivost. Če je pomivalni stroj star in nam povzroča težave, je priporočljivo, da kupimo novega, ki ima ustrezno zmogljivost in čim boljši energetski razred (B ali A). S tem bomo povečali prihranke na tej napravi.</p>
            </div>
          </div>
        </li>

        <li id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl01_divAction">
          <a
            class="actionBtnMore"
            style="cursor:pointer;"
          >Če imamo solarni vir ogrevanja vode, priklopimo nanj pomivalni stroj</a>

          <div style="display:none;" class="actionPnlMore">
            <div class="advice">
              <div class="right">
                <a
                  id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl01_lnkBtnAdd"
                  class="btn"
                  href="javascript:__doPostBack('ctl00$ContentPlaceHolder1$RepeaterActions$ctl01$lnkBtnAdd','')"
                >Izvedi ukrep</a>
              </div>
              <p>V primeru, ko imamo pripravo tople vode urejeno s solarnim sistemom s temperaturo do 60 °C, lahko priključimo pomivalni stroj na dovod tople vode. Na ta način prihranimo okoli 25 % električne energije.</p>
            </div>
          </div>
        </li>

        <li id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl02_divAction">
          <a class="actionBtnMore" style="cursor:pointer;">Izogibamo se programu s sušenjem posode</a>

          <div style="display:none;" class="actionPnlMore">
            <div class="advice">
              <div class="right">
                <a
                  id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl02_lnkBtnAdd"
                  class="btn"
                  href="javascript:__doPostBack('ctl00$ContentPlaceHolder1$RepeaterActions$ctl02$lnkBtnAdd','')"
                >Izvedi ukrep</a>
              </div>
              <p>Posoda se bo zaradi lastne toplote posušila tudi, če bomo stroj po končanem programu pomivanja izključili in vrata delno odprli. Če se izogibamo programu s sušenjem posode, ker je energetsko potraten, lahko prihranimo do 4 % električne energije.</p>
            </div>
          </div>
        </li>

        <li id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl03_divAction">
          <a class="actionBtnMore" style="cursor:pointer;">Pomivalni stroj vedno napolnimo do konca</a>

          <div style="display:none;" class="actionPnlMore">
            <div class="advice">
              <div class="right">
                <a
                  id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl03_lnkBtnAdd"
                  class="btn"
                  href="javascript:__doPostBack('ctl00$ContentPlaceHolder1$RepeaterActions$ctl03$lnkBtnAdd','')"
                >Izvedi ukrep</a>
              </div>
              <p>Če pomivalni stroj vedno napolnimo do konca, po potrebi s posodo od več obrokov, in na ta način zmanjšamo število pranj, lahko prihranimo okoli 3 % električne energije.</p>
            </div>
          </div>
        </li>

        <li id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl04_divAction">
          <a
            class="actionBtnMore"
            style="cursor:pointer;"
          >Za manj umazano posodo izberemo varčen (ekonomičen) program ali program z nižjo temperaturo</a>

          <div style="display:none;" class="actionPnlMore">
            <div class="advice">
              <div class="right">
                <a
                  id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl04_lnkBtnAdd"
                  class="btn"
                  href="javascript:__doPostBack('ctl00$ContentPlaceHolder1$RepeaterActions$ctl04$lnkBtnAdd','')"
                >Izvedi ukrep</a>
              </div>
              <p>Če za manj umazano posodo izberemo varčen (ekonomičen) program ali program z nižjo temperaturo, lahko prihranimo okoli 2 % električne energije.</p>
            </div>
          </div>
        </li>

        <li id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl05_divAction">
          <a class="actionBtnMore" style="cursor:pointer;">Perimo le v času nižje tarife (MT)</a>

          <div style="display:none;" class="actionPnlMore">
            <div class="advice">
              <div class="right">
                <a
                  id="ctl00_ContentPlaceHolder1_RepeaterActions_ctl05_lnkBtnAdd"
                  class="btn"
                  href="javascript:__doPostBack('ctl00$ContentPlaceHolder1$RepeaterActions$ctl05$lnkBtnAdd','')"
                >Izvedi ukrep</a>
              </div>
              <p>
                Če peremo posodo le
                <a
                  href="http://www.uresnicujmo.si/o_aplikaciji_za_izracun_prihrankov#tarife"
                  target="_blank"
                >v času nižje tarife</a>, lahko v primerjavi s pranjem le v času višje tarife (VT) prihranimo na stroških porabljene energije, ki jo porabi samo pomivalni stroj, okoli 30 %.
              </p>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="advice">
      <h4>Imejte vedno v mislih, da lahko prihranite!</h4>
      <p>Zgornji ukrepi so merljivi in ob njihovem izvajanju točno veste, koliko energije lahko prihranite. Toda za vse električne naprave v gospodinjstvu, tako večje kot majhne, smo zbrali še kopico nasvetov, ki vam lahko pomagajo dodatno prihraniti, čeprav prihranka zaradi različnosti naprav in situacij za te nasvete ni mogoče količinsko opredeliti.</p>
      <a
        href="http://www.uresnicujmo.si/nasveti/hladilnik"
        target="_blank"
        alt="več"
        class="more"
      >PREBERITE NASVETE</a>
    </div>
  </div>
  <div class="content r-c">
    <div class="c282">
      <h3>PORABA NAPRAVE POMIVALNI STROJ 1</h3>
      <div class="select">
        <select
          name="ctl00$ContentPlaceHolder1$ddlUsageType"
          onchange="javascript:setTimeout('__doPostBack(\'ctl00$ContentPlaceHolder1$ddlUsageType\',\'\')', 0)"
          id="ctl00_ContentPlaceHolder1_ddlUsageType"
          class="s156"
        >
          <option selected="selected" value="1">Kumulativna poraba (€)</option>
          <option value="2">Kumulativna poraba (kWh)</option>
        </select>
        <select
          name="ctl00$ContentPlaceHolder1$ddlUsageTSpan"
          onchange="javascript:setTimeout('__doPostBack(\'ctl00$ContentPlaceHolder1$ddlUsageTSpan\',\'\')', 0)"
          id="ctl00_ContentPlaceHolder1_ddlUsageTSpan"
        >
          <option selected="selected" value="1">za 1 leto</option>
          <option value="5">za 5 let</option>
          <option value="10">za 10 let</option>
          <option value="15">za 15 let</option>
        </select>
      </div>

      <div class="graph">
        <div class="chart">
          <div
            id="ctl00_ContentPlaceHolder1_divCurrentUsage"
            class="col without"
            style="height:100%;"
          >
            <span id="ctl00_ContentPlaceHolder1_lblCurrentUsage">22,57 €</span>
          </div>
        </div>
        <div class="legend">
          <div class="col">
            <strong>Poraba brez</strong> izvedenih ukrepov
          </div>
          <div class="col">
            <strong>Poraba z</strong> izvedenimi ukrepi
          </div>
        </div>
      </div>
    </div>
    <div class="c282">
      <h3>PORABA NAPRAVE POMIVALNI STROJ 1</h3>
      <div class="select">
        <select
          name="ctl00$ContentPlaceHolder1$ddlUsageType2"
          onchange="javascript:setTimeout('__doPostBack(\'ctl00$ContentPlaceHolder1$ddlUsageType2\',\'\')', 0)"
          id="ctl00_ContentPlaceHolder1_ddlUsageType2"
          class="s156"
        >
          <option selected="selected" value="1">Kumulativna poraba (€)</option>
          <option value="2">Kumulativna poraba (kWh)</option>
        </select>
        <select
          name="ctl00$ContentPlaceHolder1$ddlUsageTSpan2"
          onchange="javascript:setTimeout('__doPostBack(\'ctl00$ContentPlaceHolder1$ddlUsageTSpan2\',\'\')', 0)"
          id="ctl00_ContentPlaceHolder1_ddlUsageTSpan2"
        >
          <option value="1">za 1 leto</option>
          <option selected="selected" value="5">za 5 let</option>
          <option value="10">za 10 let</option>
          <option value="15">za 15 let</option>
        </select>
      </div>
      <div class="graph image">
        <div class="chart">
          <img
            id="ctl00_ContentPlaceHolder1_Chart1"
            src="/Images/Charts/Chart000003.png?e55aa4aa-54d2-4ec8-9e1a-1db750a5d92a"
            alt
            usemap="#ctl00_ContentPlaceHolder1_Chart1ImageMap"
            style="height:168px;width:263px;border-width:0px;padding:0;"
          />
          <map
            name="ctl00_ContentPlaceHolder1_Chart1ImageMap"
            id="ctl00_ContentPlaceHolder1_Chart1ImageMap"
          >
            <area
              shape="poly"
              coords="200, 144, 200, 48, 200, 48, 257, 18, 257, 18, 257, 144, 200, 144"
              title="13.11.2025; 112,844095"
              alt
            />
            <area
              shape="poly"
              coords="144, 144, 144, 79, 144, 79, 200, 48, 200, 48, 200, 144, 144, 144"
              title="13.11.2024; 90,275276"
              alt
            />
            <area
              shape="poly"
              coords="87, 144, 87, 110, 87, 110, 144, 79, 144, 79, 144, 144, 87, 144"
              title="13.11.2023; 67,706457"
              alt
            />
            <area
              shape="poly"
              coords="30, 144, 30, 140, 30, 140, 87, 110, 87, 110, 87, 144, 30, 144"
              title="13.11.2022; 45,137638"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 18, 257, 18, 30, 140, 30, 140, 30, 144, 257, 144"
              title="13.11.2021; 22,568819"
              alt
            />
            <area
              shape="poly"
              coords="200, 144, 200, 48, 200, 48, 257, 18, 257, 18, 257, 144, 200, 144"
              title="13.11.2025; 112,844095"
              alt
            />
            <area
              shape="poly"
              coords="144, 144, 144, 79, 144, 79, 200, 48, 200, 48, 200, 144, 144, 144"
              title="13.11.2024; 90,275276"
              alt
            />
            <area
              shape="poly"
              coords="87, 144, 87, 110, 87, 110, 144, 79, 144, 79, 144, 144, 87, 144"
              title="13.11.2023; 67,706457"
              alt
            />
            <area
              shape="poly"
              coords="30, 144, 30, 140, 30, 140, 87, 110, 87, 110, 87, 144, 30, 144"
              title="13.11.2022; 45,137638"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 18, 257, 18, 30, 140, 30, 140, 30, 144, 257, 144"
              title="13.11.2021; 22,568819"
              alt
            />
            <area
              shape="poly"
              coords="200, 144, 200, 48, 200, 48, 257, 18, 257, 18, 257, 144, 200, 144"
              title="13.11.2025; 112,844095"
              alt
            />
            <area
              shape="poly"
              coords="144, 144, 144, 79, 144, 79, 200, 48, 200, 48, 200, 144, 144, 144"
              title="13.11.2024; 90,275276"
              alt
            />
            <area
              shape="poly"
              coords="87, 144, 87, 110, 87, 110, 144, 79, 144, 79, 144, 144, 87, 144"
              title="13.11.2023; 67,706457"
              alt
            />
            <area
              shape="poly"
              coords="30, 144, 30, 140, 30, 140, 87, 110, 87, 110, 87, 144, 30, 144"
              title="13.11.2022; 45,137638"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 18, 257, 18, 30, 140, 30, 140, 30, 144, 257, 144"
              title="13.11.2021; 22,568819"
              alt
            />
            <area
              shape="poly"
              coords="200, 144, 200, 48, 200, 48, 257, 18, 257, 18, 257, 144, 200, 144"
              title="13.11.2025; 112,844095"
              alt
            />
            <area
              shape="poly"
              coords="144, 144, 144, 79, 144, 79, 200, 48, 200, 48, 200, 144, 144, 144"
              title="13.11.2024; 90,275276"
              alt
            />
            <area
              shape="poly"
              coords="87, 144, 87, 110, 87, 110, 144, 79, 144, 79, 144, 144, 87, 144"
              title="13.11.2023; 67,706457"
              alt
            />
            <area
              shape="poly"
              coords="30, 144, 30, 140, 30, 140, 87, 110, 87, 110, 87, 144, 30, 144"
              title="13.11.2022; 45,137638"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 18, 257, 18, 30, 140, 30, 140, 30, 144, 257, 144"
              title="13.11.2021; 22,568819"
              alt
            />
            <area
              shape="poly"
              coords="200, 144, 200, 48, 200, 48, 257, 18, 257, 18, 257, 144, 200, 144"
              title="13.11.2025; 112,844095"
              alt
            />
            <area
              shape="poly"
              coords="144, 144, 144, 79, 144, 79, 200, 48, 200, 48, 200, 144, 144, 144"
              title="13.11.2024; 90,275276"
              alt
            />
            <area
              shape="poly"
              coords="87, 144, 87, 110, 87, 110, 144, 79, 144, 79, 144, 144, 87, 144"
              title="13.11.2023; 67,706457"
              alt
            />
            <area
              shape="poly"
              coords="30, 144, 30, 140, 30, 140, 87, 110, 87, 110, 87, 144, 30, 144"
              title="13.11.2022; 45,137638"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 18, 257, 18, 30, 140, 30, 140, 30, 144, 257, 144"
              title="13.11.2021; 22,568819"
              alt
            />
            <area
              shape="poly"
              coords="200, 144, 200, 48, 200, 48, 257, 18, 257, 18, 257, 144, 200, 144"
              title="13.11.2025; 112,844095"
              alt
            />
            <area
              shape="poly"
              coords="144, 144, 144, 79, 144, 79, 200, 48, 200, 48, 200, 144, 144, 144"
              title="13.11.2024; 90,275276"
              alt
            />
            <area
              shape="poly"
              coords="87, 144, 87, 110, 87, 110, 144, 79, 144, 79, 144, 144, 87, 144"
              title="13.11.2023; 67,706457"
              alt
            />
            <area
              shape="poly"
              coords="30, 144, 30, 140, 30, 140, 87, 110, 87, 110, 87, 144, 30, 144"
              title="13.11.2022; 45,137638"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 18, 257, 18, 30, 140, 30, 140, 30, 144, 257, 144"
              title="13.11.2021; 22,568819"
              alt
            />
            <area
              shape="poly"
              coords="200, 144, 200, 48, 200, 48, 257, 18, 257, 18, 257, 144, 200, 144"
              title="13.11.2025; 112,844095"
              alt
            />
            <area
              shape="poly"
              coords="144, 144, 144, 79, 144, 79, 200, 48, 200, 48, 200, 144, 144, 144"
              title="13.11.2024; 90,275276"
              alt
            />
            <area
              shape="poly"
              coords="87, 144, 87, 110, 87, 110, 144, 79, 144, 79, 144, 144, 87, 144"
              title="13.11.2023; 67,706457"
              alt
            />
            <area
              shape="poly"
              coords="30, 144, 30, 140, 30, 140, 87, 110, 87, 110, 87, 144, 30, 144"
              title="13.11.2022; 45,137638"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 18, 257, 18, 30, 140, 30, 140, 30, 144, 257, 144"
              title="13.11.2021; 22,568819"
              alt
            />
            <area
              shape="poly"
              coords="200, 144, 200, 48, 200, 48, 257, 18, 257, 18, 257, 144, 200, 144"
              title="13.11.2025; 112,844095"
              alt
            />
            <area
              shape="poly"
              coords="144, 144, 144, 79, 144, 79, 200, 48, 200, 48, 200, 144, 144, 144"
              title="13.11.2024; 90,275276"
              alt
            />
            <area
              shape="poly"
              coords="87, 144, 87, 110, 87, 110, 144, 79, 144, 79, 144, 144, 87, 144"
              title="13.11.2023; 67,706457"
              alt
            />
            <area
              shape="poly"
              coords="30, 144, 30, 140, 30, 140, 87, 110, 87, 110, 87, 144, 30, 144"
              title="13.11.2022; 45,137638"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 18, 257, 18, 30, 140, 30, 140, 30, 144, 257, 144"
              title="13.11.2021; 22,568819"
              alt
            />
            <area
              shape="poly"
              coords="200, 144, 200, 48, 200, 48, 257, 18, 257, 18, 257, 144, 200, 144"
              title="13.11.2025; 112,844095"
              alt
            />
            <area
              shape="poly"
              coords="144, 144, 144, 79, 144, 79, 200, 48, 200, 48, 200, 144, 144, 144"
              title="13.11.2024; 90,275276"
              alt
            />
            <area
              shape="poly"
              coords="87, 144, 87, 110, 87, 110, 144, 79, 144, 79, 144, 144, 87, 144"
              title="13.11.2023; 67,706457"
              alt
            />
            <area
              shape="poly"
              coords="30, 144, 30, 140, 30, 140, 87, 110, 87, 110, 87, 144, 30, 144"
              title="13.11.2022; 45,137638"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 18, 257, 18, 30, 140, 30, 140, 30, 144, 257, 144"
              title="13.11.2021; 22,568819"
              alt
            />
            <area
              shape="poly"
              coords="200, 144, 200, 48, 200, 48, 257, 18, 257, 18, 257, 144, 200, 144"
              title="13.11.2025; 112,844095"
              alt
            />
            <area
              shape="poly"
              coords="144, 144, 144, 79, 144, 79, 200, 48, 200, 48, 200, 144, 144, 144"
              title="13.11.2024; 90,275276"
              alt
            />
            <area
              shape="poly"
              coords="87, 144, 87, 110, 87, 110, 144, 79, 144, 79, 144, 144, 87, 144"
              title="13.11.2023; 67,706457"
              alt
            />
            <area
              shape="poly"
              coords="30, 144, 30, 140, 30, 140, 87, 110, 87, 110, 87, 144, 30, 144"
              title="13.11.2022; 45,137638"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 18, 257, 18, 30, 140, 30, 140, 30, 144, 257, 144"
              title="13.11.2021; 22,568819"
              alt
            />
            <area
              shape="poly"
              coords="200, 144, 200, 48, 200, 48, 257, 18, 257, 18, 257, 144, 200, 144"
              title="13.11.2025; 112,844095"
              alt
            />
            <area
              shape="poly"
              coords="144, 144, 144, 79, 144, 79, 200, 48, 200, 48, 200, 144, 144, 144"
              title="13.11.2024; 90,275276"
              alt
            />
            <area
              shape="poly"
              coords="87, 144, 87, 110, 87, 110, 144, 79, 144, 79, 144, 144, 87, 144"
              title="13.11.2023; 67,706457"
              alt
            />
            <area
              shape="poly"
              coords="30, 144, 30, 140, 30, 140, 87, 110, 87, 110, 87, 144, 30, 144"
              title="13.11.2022; 45,137638"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 18, 257, 18, 30, 140, 30, 140, 30, 144, 257, 144"
              title="13.11.2021; 22,568819"
              alt
            />
            <area
              shape="poly"
              coords="200, 144, 200, 48, 200, 48, 257, 18, 257, 18, 257, 144, 200, 144"
              title="13.11.2025; 112,844095"
              alt
            />
            <area
              shape="poly"
              coords="144, 144, 144, 79, 144, 79, 200, 48, 200, 48, 200, 144, 144, 144"
              title="13.11.2024; 90,275276"
              alt
            />
            <area
              shape="poly"
              coords="87, 144, 87, 110, 87, 110, 144, 79, 144, 79, 144, 144, 87, 144"
              title="13.11.2023; 67,706457"
              alt
            />
            <area
              shape="poly"
              coords="30, 144, 30, 140, 30, 140, 87, 110, 87, 110, 87, 144, 30, 144"
              title="13.11.2022; 45,137638"
              alt
            />
            <area
              shape="poly"
              coords="257, 144, 257, 18, 257, 18, 30, 140, 30, 140, 30, 144, 257, 144"
              title="13.11.2021; 22,568819"
              alt
            />
            <area
              shape="poly"
              coords="200, 144, 200, 48, 200, 48, 257, 18, 257, 18, 257, 144, 200, 144"
              title="13.11.2025; 112,844095"
              alt
            />
            <area
              shape="poly"
              coords="144, 144, 144, 79, 144, 79, 200, 48, 200, 48, 200, 144, 144, 144"
              title="13.11.2024; 90,275276"
              alt
            />
            <area
              shape="poly"
              coords="87, 144, 87, 110, 87, 110, 144, 79, 144, 79, 144, 144, 87, 144"
              title="13.11.2023; 67,706457"
              alt
            />
            <area
              shape="poly"
              coords="30, 144, 30, 140, 30, 140, 87, 110, 87, 110, 87, 144, 30, 144"
              title="13.11.2022; 45,137638"
              alt
            />
          </map>
        </div>
        <div class="legend">
          <ul>
            <li class="without">Poraba brez izvedenih ukrepov</li>
            <li class="with">Poraba z izvedenimi ukrepi</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>